import React from 'react'
import styled from 'styled-components'
import { pluralize } from 'utils/pluralize'
import { Link } from 'lib/Link'
import { StarRating } from 'lib/StarRating'
import { Text } from 'lib/Text'

const Container = styled.div`
  display: flex;
  align-items: center;
`

const Count = styled(Text)`
  margin-left: 8px;
`

interface Props {
  averageRating: number
  ratingsCount: number
  brandSlug: string
  className?: string
}
export const ReviewSummary = ({ averageRating, brandSlug, ratingsCount, className }: Props) => {
  const roundedRating = Math.round(averageRating * 10) / 10

  return (
    <Container className={className}>
      <StarRating stars={roundedRating} />{' '}
      <Count size="pxs" color="black-80">
        {roundedRating} •{' '}
        <Link underlineOnNormalState={false} href={`/brands/${brandSlug}/reviews`}>
          {pluralize(ratingsCount, 'Review', 'Reviews')}
        </Link>
      </Count>
    </Container>
  )
}
